/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AgeRestrictionEnum {
  NA = "NA",
  y100 = "y100",
  y110 = "y110",
  y12 = "y12",
  y120 = "y120",
  y130 = "y130",
  y14 = "y14",
  y140 = "y140",
  y150 = "y150",
  y16 = "y16",
  y18 = "y18",
  y30 = "y30",
  y35 = "y35",
  y40 = "y40",
  y45 = "y45",
  y50 = "y50",
  y55 = "y55",
  y60 = "y60",
  y65 = "y65",
  y70 = "y70",
  y75 = "y75",
  y80 = "y80",
  y85 = "y85",
  y90 = "y90",
  y95 = "y95",
}

export enum AgeRestrictionModifierEnum {
  OVER = "OVER",
  UNDER = "UNDER",
}

export enum DistrictEnum {
  ALABAMA = "ALABAMA",
  ALASKA = "ALASKA",
  ALLEGHENY_MOUNTAIN = "ALLEGHENY_MOUNTAIN",
  AMERICAN_SAMOA_GUAM = "AMERICAN_SAMOA_GUAM",
  ARKANSAS = "ARKANSAS",
  BRITISH_COLUMBIA = "BRITISH_COLUMBIA",
  CENTRAL_ARIZONA = "CENTRAL_ARIZONA",
  CENTRAL_INDIANA = "CENTRAL_INDIANA",
  CENTRAL_PENNSYLVANIA = "CENTRAL_PENNSYLVANIA",
  CHICAGO = "CHICAGO",
  COLORADO = "COLORADO",
  CONNECTICUT = "CONNECTICUT",
  DELAWARE = "DELAWARE",
  EASTERN_MASSACHUSETTS = "EASTERN_MASSACHUSETTS",
  EASTERN_PENNSYLVANIA = "EASTERN_PENNSYLVANIA",
  EASTERN_WASHINGTON = "EASTERN_WASHINGTON",
  EAST_HAWAII = "EAST_HAWAII",
  GEORGIA = "GEORGIA",
  GREATER_EL_PASO = "GREATER_EL_PASO",
  HEART_OF_AMERICA = "HEART_OF_AMERICA",
  IDAHO = "IDAHO",
  IOWA = "IOWA",
  KANSAS = "KANSAS",
  KAUAI = "KAUAI",
  KENTUCKY = "KENTUCKY",
  LONG_ISLAND_REGION = "LONG_ISLAND_REGION",
  LOUISIANA = "LOUISIANA",
  MAINE = "MAINE",
  MARYLAND = "MARYLAND",
  MAUI = "MAUI",
  MEMBER = "MEMBER",
  METROPOLITAN_REGION = "METROPOLITAN_REGION",
  MID_SOUTH_ILLINOIS_TENNIS_ASSOCIATION = "MID_SOUTH_ILLINOIS_TENNIS_ASSOCIATION",
  MISSISSIPPI = "MISSISSIPPI",
  MISSOURI = "MISSOURI",
  MONTANA = "MONTANA",
  NEBRASKA = "NEBRASKA",
  NEVADA = "NEVADA",
  NEW_HAMPSHIRE = "NEW_HAMPSHIRE",
  NEW_JERSEY = "NEW_JERSEY",
  NEW_JERSEY_REGION = "NEW_JERSEY_REGION",
  NORTHEASTERN_OHIO = "NORTHEASTERN_OHIO",
  NORTHERN_ARIZONA = "NORTHERN_ARIZONA",
  NORTHERN_CALIFORNIA = "NORTHERN_CALIFORNIA",
  NORTHERN_ILLINOIS = "NORTHERN_ILLINOIS",
  NORTHERN_INDIANA = "NORTHERN_INDIANA",
  NORTHERN_MICHIGAN = "NORTHERN_MICHIGAN",
  NORTHERN_NEW_MEXICO = "NORTHERN_NEW_MEXICO",
  NORTHERN_OREGON = "NORTHERN_OREGON",
  NORTHERN_REGION = "NORTHERN_REGION",
  NORTHWESTERN_OHIO = "NORTHWESTERN_OHIO",
  NORTHWEST_WASHINGTON = "NORTHWEST_WASHINGTON",
  NORTH_CAROLINA = "NORTH_CAROLINA",
  N_E_MICHIGAN = "N_E_MICHIGAN",
  OAHU = "OAHU",
  OHIO_VALLEY = "OHIO_VALLEY",
  OKLAHOMA = "OKLAHOMA",
  PHILADELPHIA = "PHILADELPHIA",
  PUERTO_RICO = "PUERTO_RICO",
  REGION_1 = "REGION_1",
  REGION_2 = "REGION_2",
  REGION_3 = "REGION_3",
  REGION_4 = "REGION_4",
  REGION_5 = "REGION_5",
  REGION_6 = "REGION_6",
  REGION_7 = "REGION_7",
  REGION_8 = "REGION_8",
  RHODE_ISLAND = "RHODE_ISLAND",
  SAN_DIEGO = "SAN_DIEGO",
  SOUTHEASTERN_NEW_MEXICO = "SOUTHEASTERN_NEW_MEXICO",
  SOUTHERN_ARIZONA = "SOUTHERN_ARIZONA",
  SOUTHERN_CALIFORNIA = "SOUTHERN_CALIFORNIA",
  SOUTHERN_NEW_MEXICO = "SOUTHERN_NEW_MEXICO",
  SOUTHERN_OREGON = "SOUTHERN_OREGON",
  SOUTHERN_REGION = "SOUTHERN_REGION",
  SOUTHWEST_WASHINGTON = "SOUTHWEST_WASHINGTON",
  SOUTH_CAROLINA = "SOUTH_CAROLINA",
  ST_LOUIS = "ST_LOUIS",
  S_E_MICHIGAN = "S_E_MICHIGAN",
  TENNESSEE = "TENNESSEE",
  UNASSIGNED = "UNASSIGNED",
  UTAH = "UTAH",
  VERMONT = "VERMONT",
  VIRGINIA = "VIRGINIA",
  VIRGIN_ISLANDS = "VIRGIN_ISLANDS",
  WASHINGTON_DC = "WASHINGTON_DC",
  WESTERN_MASSACHUSETTS = "WESTERN_MASSACHUSETTS",
  WESTERN_MICHIGAN = "WESTERN_MICHIGAN",
  WESTERN_REGION = "WESTERN_REGION",
  WEST_HAWAII = "WEST_HAWAII",
  WEST_VIRGINIA = "WEST_VIRGINIA",
  WISCONSIN = "WISCONSIN",
  WYOMING = "WYOMING",
}

export enum DivisionTypeEnum {
  A = "A",
  AGE = "AGE",
  B = "B",
  C = "C",
  D = "D",
  NTRP = "NTRP",
  QUAD = "QUAD",
}

export enum FamilyCategoryEnum {
  FATHER_DAUGHTER = "FATHER_DAUGHTER",
  FATHER_SON = "FATHER_SON",
  GRANDFATHER_GRANDDAUGHTER = "GRANDFATHER_GRANDDAUGHTER",
  GRANDFATHER_GRANDSON = "GRANDFATHER_GRANDSON",
  GRANDMOTHER_GRANDDAUGHTER = "GRANDMOTHER_GRANDDAUGHTER",
  GRANDMOTHER_GRANDSON = "GRANDMOTHER_GRANDSON",
  HUSBAND_WIFE = "HUSBAND_WIFE",
  MOTHER_DAUGHTER = "MOTHER_DAUGHTER",
  MOTHER_SON = "MOTHER_SON",
  SAME_GENDER_FEMALE = "SAME_GENDER_FEMALE",
  SAME_GENDER_MALE = "SAME_GENDER_MALE",
}

export enum ListTypeEnum {
  BONUS_POINTS = "BONUS_POINTS",
  DIRECT_ACCEPTANCE = "DIRECT_ACCEPTANCE",
  L2_QUALIFIER = "L2_QUALIFIER",
  QUOTA = "QUOTA",
  SEEDING = "SEEDING",
  STANDING = "STANDING",
  YEAR_END = "YEAR_END",
}

export enum MatchFormatEnum {
  COMBINED = "COMBINED",
  DOUBLES = "DOUBLES",
  SINGLES = "SINGLES",
}

export enum MatchFormatTypeEnum {
  INDIVIDUAL = "INDIVIDUAL",
  TEAM = "TEAM",
}

export enum PlayerLevelEnum {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  L2_5 = "L2_5",
  L3_0 = "L3_0",
  L3_5 = "L3_5",
  L4_0 = "L4_0",
  L4_5 = "L4_5",
  L5_0 = "L5_0",
  Op = "Op",
  QUAD = "QUAD",
}

export enum PlayerTypeEnum {
  ADULT = "ADULT",
  FAMILY = "FAMILY",
  INVALID = "INVALID",
  JUNIOR = "JUNIOR",
  WHEELCHAIR = "WHEELCHAIR",
}

export enum RankListGenderEnum {
  C = "C",
  F = "F",
  M = "M",
  X = "X",
}

export enum RankListGenderModifierEnum {
  F = "F",
  M = "M",
}

export enum RankListRegionEnum {
  S05 = "S05",
  S10 = "S10",
  S15 = "S15",
  S20 = "S20",
  S25 = "S25",
  S30 = "S30",
  S35 = "S35",
  S40 = "S40",
  S45 = "S45",
  S50 = "S50",
  S55 = "S55",
  S60 = "S60",
  S65 = "S65",
  S70 = "S70",
  S75 = "S75",
  S80 = "S80",
  S85 = "S85",
}

export enum RankListRunGroupSortFieldsEnum {
  AGE_RESTRICTION = "AGE_RESTRICTION",
  FAMILY_CATEGORY = "FAMILY_CATEGORY",
  GENDER = "GENDER",
  GENDER_MODIFIER = "GENDER_MODIFIER",
  LATEST_LIST_CREATED_AT = "LATEST_LIST_CREATED_AT",
  LATEST_LIST_PUBLISH_DATE = "LATEST_LIST_PUBLISH_DATE",
  LATEST_LIST_VISIBLE = "LATEST_LIST_VISIBLE",
  LIST_TYPE = "LIST_TYPE",
  MATCH_FORMAT = "MATCH_FORMAT",
  MATCH_FORMAT_TYPE = "MATCH_FORMAT_TYPE",
  PLAYER_LEVEL = "PLAYER_LEVEL",
  PLAYER_TYPE = "PLAYER_TYPE",
}

export enum RankListSchedulePeriodEnum {
  ONE_MONTH = "ONE_MONTH",
  ONE_YEAR = "ONE_YEAR",
}

export enum RankListSortFieldsEnum {
  AGE_RESTRICTION = "AGE_RESTRICTION",
  CREATED_AT = "CREATED_AT",
  DATE_RANGE_END = "DATE_RANGE_END",
  DATE_RANGE_START = "DATE_RANGE_START",
  GENDER = "GENDER",
  ITEM_COUNT = "ITEM_COUNT",
  PLAYER_LEVEL = "PLAYER_LEVEL",
  PUBLISH_DATE = "PUBLISH_DATE",
  REGION = "REGION",
  UPDATED_AT = "UPDATED_AT",
  VISIBLE = "VISIBLE",
}

export enum SectionEnum {
  CARIBBEAN = "CARIBBEAN",
  EASTERN = "EASTERN",
  FLORIDA = "FLORIDA",
  HAWAII_PACIFIC = "HAWAII_PACIFIC",
  INTERMOUNTAIN = "INTERMOUNTAIN",
  INTERNATIONAL = "INTERNATIONAL",
  MIDDLE_STATES = "MIDDLE_STATES",
  MIDWEST = "MIDWEST",
  MID_ATLANTIC = "MID_ATLANTIC",
  MISSOURI_VALLEY = "MISSOURI_VALLEY",
  NEW_ENGLAND = "NEW_ENGLAND",
  NORTHERN = "NORTHERN",
  NORTHERN_CALIFORNIA = "NORTHERN_CALIFORNIA",
  PACIFIC_NW = "PACIFIC_NW",
  SOUTHERN = "SOUTHERN",
  SOUTHERN_CALIFORNIA = "SOUTHERN_CALIFORNIA",
  SOUTHWEST = "SOUTHWEST",
  TEXAS = "TEXAS",
  UNASSIGNED = "UNASSIGNED",
}

export enum SortDirectionEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export interface AddRankListItemInput {
  rankListId?: string | null;
  participants?: AddRankListParticipantInput[] | null;
  rank: number;
  wildcard?: number | null;
  wins?: MatchFormatDistributionInput | null;
  losses?: MatchFormatDistributionInput | null;
  points?: PointsDistributionInput | null;
}

export interface AddRankListParticipantInput {
  itemId: string;
  name: string;
  birthDate: string;
  city: string;
  state: string;
  section: SectionEnum;
  district: DistrictEnum;
}

export interface DateOperators {
  eq?: any | null;
  before?: any | null;
  after?: any | null;
  between?: DateRange | null;
}

export interface DateRange {
  start: any;
  end: any;
}

export interface DistrictOperators {
  eq?: DistrictEnum | null;
  in?: DistrictEnum[] | null;
  nin?: DistrictEnum[] | null;
}

export interface GenerateRankListInput {
  listType?: ListTypeEnum | null;
  playerType?: PlayerTypeEnum | null;
  familyCategory?: FamilyCategoryEnum | null;
  playerLevel?: PlayerLevelEnum | null;
  gender?: RankListGenderEnum | null;
  genderModifier?: RankListGenderModifierEnum | null;
  ageRestriction?: AgeRestrictionEnum | null;
  matchFormat?: MatchFormatEnum | null;
  matchFormatType?: MatchFormatTypeEnum | null;
  itemLimit?: number | null;
  region?: RankListRegionEnum | null;
  dateRange?: RankListDateRangeInput | null;
  runDate?: any | null;
}

export interface LocalityFilterInput {
  section?: SectionOperators | null;
  district?: DistrictOperators | null;
  state?: StateLocaleOperators | null;
}

export interface MatchFormatDistributionInput {
  singles?: number | null;
  doubles?: number | null;
  total?: number | null;
}

export interface PaginationArgs {
  limit?: number | null;
  skip?: number | null;
}

export interface PointsDistributionInput {
  singles?: number | null;
  doubles?: number | null;
  bonus?: number | null;
  total?: number | null;
}

export interface RankListDateRangeInput {
  start?: any | null;
  end?: any | null;
}

export interface RankListFilterInput {
  playerType?: PlayerTypeEnum | null;
  familyCategory?: FamilyCategoryEnum | null;
  playerLevel?: PlayerLevelEnum | null;
  divisionType?: DivisionTypeEnum | null;
  gender?: RankListGenderEnum | null;
  ageRestriction?: AgeRestrictionEnum | null;
  region?: RankListRegionEnum | null;
  genderModifier?: RankListGenderModifierEnum | null;
  ageRestrictionModifier?: AgeRestrictionModifierEnum | null;
  matchFormat?: MatchFormatEnum | null;
  matchFormatType?: MatchFormatTypeEnum | null;
  visible?: boolean | null;
  publishDate?: DateOperators | null;
  listType?: ListTypeEnum | null;
  createdAt?: DateOperators | null;
  updatedAt?: DateOperators | null;
  scheduleId?: string | null;
}

export interface RankListItemFilterInput {
  localityFilter?: LocalityFilterInput | null;
  participantIds?: string[] | null;
  participantIdSearch?: string | null;
  participantName?: string | null;
  wildcard?: boolean | null;
  wildcardIndex?: number | null;
}

export interface RankListRunGroupFilterInput {
  playerType?: PlayerTypeEnum | null;
  familyCategory?: FamilyCategoryEnum | null;
  playerLevel?: PlayerLevelEnum | null;
  listType?: ListTypeEnum | null;
  ageRestriction?: AgeRestrictionEnum | null;
  gender?: RankListGenderEnum | null;
  genderModifier?: RankListGenderModifierEnum | null;
  matchFormat?: MatchFormatEnum | null;
  matchFormatType?: MatchFormatTypeEnum | null;
  divisionType?: DivisionTypeEnum | null;
  latestListPublishDate?: DateOperators | null;
  region?: RankListRegionEnum | null;
  latestListVisible?: boolean | null;
  scheduleId?: string | null;
}

export interface RankListRunGroupSort {
  field: RankListRunGroupSortFieldsEnum;
  direction: SortDirectionEnum;
}

export interface RankListScheduleFilter {
  id?: string | null;
  ids?: (string | null)[] | null;
  frequency?: any | null;
  period?: RankListSchedulePeriodEnum | null;
  input?: GenerateRankListInput | null;
}

export interface RankListSort {
  field: RankListSortFieldsEnum;
  direction: SortDirectionEnum;
}

export interface SectionOperators {
  eq?: SectionEnum | null;
  in?: SectionEnum[] | null;
  nin?: SectionEnum[] | null;
}

export interface StateLocaleOperators {
  eq?: string | null;
  in?: string[] | null;
  nin?: string[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
